import { DataRecord, RecordKind } from './record.js';
class Product extends DataRecord {
    constructor(_class, model, constraints = [], id, filters = null) {
        super(_class, RecordKind.Product, id);
        this.constraints = [];
        this.model = model;
        this.filters = filters;
        this.constraints = constraints;
    }
}
class ProductGroup extends DataRecord {
    constructor(_class, children, model, id) {
        super(_class, RecordKind.ProductGroup, id);
        this.model = {};
        this.children = children;
        this.model = model;
    }
}
export { Product, ProductGroup };
//# sourceMappingURL=product.js.map